import React, {useState} from 'react';
import {
  Box,
  Input as NativeInput,
  FormControl,
  Pressable,
  View,
  Modal,
} from 'native-base';
import {FieldError, useController, UseControllerProps} from 'react-hook-form';
import 'react-modern-calendar-datepicker-fix/lib/DatePicker.css';
import {Calendar} from 'react-modern-calendar-datepicker-fix';
import './../../../theme/web/web-style.css';
import {locale} from './web/custom-locale';
import {message} from '../../../utils/messages';
import {CalendarIcon} from '../../icons';
import {defaultProps} from '../constants';
import {SecondaryButton} from '../../buttons';

interface Props extends UseControllerProps<any> {
  label: string;
  error: FieldError | undefined;
  onConfirm?: (date: Date) => void;
}

const InputElement = () => {
  return (
    <Box marginLeft={5}>
      <CalendarIcon width="20" height="20" color="blue.400" />
    </Box>
  );
};

const DateInput = (props: Props) => {
  const {label, error, control, name, rules} = props;
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const {field} = useController({control, defaultValue: '', name, rules});

  const showDatePicker = () => {
    setDatePickerVisibility(true);
  };

  const hideDatePicker = () => {
    setDatePickerVisibility(false);
  };

  const getMonth = (date: Date) => {
    return date.getMonth() + 1;
  };

  const formatDate = (date: Date | null) => {
    let day = '';
    let month = '';
    let year = '';
    if (date) {
      day = date.getDate().toString().padStart(2, '0');
      month = getMonth(date).toString().padStart(2, '0');
      year = date.getFullYear().toString();
    }
    return date ? `${day}/${month}/${year}` : '';
  };

  const getErrorMessage = () => {
    return error != null ? message(error.message as string) : '';
  };

  const handleCalendarSelection = (value: any) => {
    hideDatePicker();
    field.onChange(
      new Date(value.year, (value.month as number) - 1, value.day),
    );
    setSelectedDay(value);
  };

  const getMaximumDate = () => {
    const date = new Date();
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isRequired isInvalid={error != null}>
        <FormControl.Label>{message(label)}</FormControl.Label>
        <Pressable onPress={showDatePicker}>
          <View pointerEvents="none">
            <NativeInput
              {...defaultProps}
              isReadOnly={true}
              InputLeftElement={<InputElement />}
              placeholder="DD/MM/AA"
              value={formatDate(field.value)}
            />
          </View>
        </Pressable>
        <FormControl.ErrorMessage>{getErrorMessage()}</FormControl.ErrorMessage>
      </FormControl>
      <Modal
        isOpen={isDatePickerVisible}
        onClose={() => setDatePickerVisibility(false)}>
        <Modal.Content backgroundColor={'white'}>
          <Modal.Body backgroundColor={'white'}>
            <Calendar
              value={selectedDay}
              onChange={handleCalendarSelection}
              calendarClassName="modal_calendar"
              colorPrimary="#0088FF"
              locale={locale}
              maximumDate={getMaximumDate()}
            />
          </Modal.Body>
          <Modal.Footer>
            <SecondaryButton
              label="calendar-button-cancel"
              onPress={() => {
                hideDatePicker();
              }}
            />
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </Box>
  );
};

export default DateInput;
/*


*/
